import React, { useState } from 'react';
import styles from './Reviews.module.scss';
import { FaChevronLeft, FaChevronRight } from 'react-icons/fa';

// Автоматично імпортуємо всі зображення з папки assets/images/reviews
const importAll = (r) => r.keys().map(r);
const reviewImages = importAll(require.context('../../assets/images/reviews/', false, /\.(png|jpe?g|svg)$/));

const Reviews = () => {
    const [currentIndex, setCurrentIndex] = useState(0);
    const [showModal, setShowModal] = useState(false);
    const [selectedImage, setSelectedImage] = useState('');
    const [touchStart, setTouchStart] = useState(null);
    const [touchEnd, setTouchEnd] = useState(null);

    const minSwipeDistance = 50;

    const goToPrevious = () => {
        const isFirstSlide = currentIndex === 0;
        const newIndex = isFirstSlide ? reviewImages.length - 1 : currentIndex - 1;
        setCurrentIndex(newIndex);
    };

    const goToNext = () => {
        const isLastSlide = currentIndex === reviewImages.length - 1;
        const newIndex = isLastSlide ? 0 : currentIndex + 1;
        setCurrentIndex(newIndex);
    };

    const handleTouchStart = (e) => {
        setTouchEnd(null);
        setTouchStart(e.targetTouches[0].clientX);
    };

    const handleTouchMove = (e) => {
        setTouchEnd(e.targetTouches[0].clientX);
    };

    const handleTouchEnd = () => {
        if (!touchStart || !touchEnd) return;
        const distance = touchStart - touchEnd;
        const isLeftSwipe = distance > minSwipeDistance;
        const isRightSwipe = distance < -minSwipeDistance;

        if (isLeftSwipe) goToNext();
        if (isRightSwipe) goToPrevious();
    };

    const handleImageClick = (imageSrc) => {
        setSelectedImage(imageSrc);
        setShowModal(true);
    };

    const handleCloseModal = () => {
        setShowModal(false);
        setSelectedImage('');
    };

    if (reviewImages.length === 0) {
        return null; // Або повідомлення про відсутність відгуків
    }

    return (
        <div className={styles.reviewsSection} id="reviews">
            <h4 className={styles.title}>Відгуки</h4>
            <div 
                className={styles.carouselContainer}
                onTouchStart={handleTouchStart}
                onTouchMove={handleTouchMove}
                onTouchEnd={handleTouchEnd}
            >
                <button onClick={goToPrevious} className={styles.leftArrow}><FaChevronLeft /></button>
                <div className={styles.carouselImage}>
                    <img
                        src={reviewImages[currentIndex]}
                        alt={`Review ${currentIndex + 1}`}
                        onClick={() => handleImageClick(reviewImages[currentIndex])}
                        style={{ cursor: 'pointer' }} // Додаємо курсор, щоб показати, що зображення клікабельне
                    />
                </div>
                <button onClick={goToNext} className={styles.rightArrow}><FaChevronRight /></button>
            </div>

            {showModal && (
                <div className={styles.modalOverlay} onClick={handleCloseModal}>
                    <div className={styles.modalContent} onClick={(e) => e.stopPropagation()}>
                        <button className={styles.closeButton} onClick={handleCloseModal}>&times;</button>
                        <img src={selectedImage} alt="Enlarged Review" className={styles.modalImageEnlarged} />
                    </div>
                </div>
            )}
        </div>
    );
};

export default Reviews;